<template>
    <div>
        <osobe-navigation
            :id="osoba_id"
            :breadcrumbs="breadcrumbs"
        >
        </osobe-navigation>
        <div class="ibox">
            <div class="ibox-title">
                <h5>Umanjeni sati</h5><br>
                <button
                    type="button"
                    class="btn btn-lg btn-primary"
                    @click.prevent="create"
                >
                    Novi unos
                </button>
            </div>
            <div class="ibox-content">
                <datatables
                    v-if="show_datatable"
                    :url="datatables_url"
                    :settings="datatables.settings"
                    :title="datatables.title"
                    @rowClick="rowClick"
                >
                </datatables>
            </div>
        </div>
    </div>
</template>

<script>
import Datatables from "../../../../components/datatable/Datatables";
import OsobeNavigation from "../OsobeNavigation";
export default {
    name: "OsobaUmanjeniSati",
    components: { OsobeNavigation, Datatables },
    data(){
        return {
            show_datatable: false,
            datatables_url: process.env.VUE_APP_API_URL +  'osoba-razdoblje-umanjeni-sat',
            datatables: {},
            breadcrumbs: [],
            osoba_id: this.$route.params.osoba_id
        }
    },
    methods:{
        rowClick( row ){
            this.$router.push( { path: '/osobe/' + this.osoba_id + '/umanjeni-sati/' + row.id } )
        },

        create(){
            this.$router.push( { path: '/osobe/' + this.osoba_id + '/umanjeni-sati/create' } )
        },

        setDatatable() {
            let vm = this;
            vm.datatables = {
                settings: {
                    table_header:[
                        {
                            'id': 'id',
                            'visible': false,
                        },
                        {
                            'id': 'osoba_id',
                            'visible': false,
                            'filter':{
                                'type': 'none',
                                'value': vm.osoba_id
                            },
                        },
                        {
                            'id': 'razdoblje_datum_od',
                            'title': 'Početak razdoblja',
                            'type' : function( row ){
                                return row.osoba_razdoblje ? row.osoba_razdoblje.datum_od : ''
                            },
                            'column_visibility_group': {
                                'id': 'umanjeni_sat',
                                'visible' : true
                            },
                            'filter': {
                                'type': 'date',
                            }
                        },
                        {
                            'id': 'razdoblje_datum_do',
                            'title': 'Kraj razdoblja',
                            'type' : function( row ){
                                return row.osoba_razdoblje ? row.osoba_razdoblje.datum_do : ''
                            },
                            'column_visibility_group': {
                                'id': 'umanjeni_sat',
                                'visible' : true
                            },
                            'filter': {
                                'type': 'date',
                            }
                        },
                        {
                            'id': 'umanjeni_sat_naziv',
                            'title': 'Umanjeni sat',
                            'type' : function( row ){
                                return row.umanjeni_sat ? row.umanjeni_sat.naziv : ''
                            },
                            'column_visibility_group': {
                                'id': 'umanjeni_sat',
                                'visible' : true
                            }
                        },

                        {
                            'id': 'datum_od',
                            'title': 'Od',
                            'type' : 'text',
                            'column_visibility_group': {
                                'id': 'umanjeni_sat',
                                'visible' : true
                            },
                            'filter': {
                                'type': 'date',
                            }
                        },
                        {
                            'id': 'datum_do',
                            'title': 'Do',
                            'type' : 'text',
                            'column_visibility_group': {
                                'id': 'umanjeni_sat',
                                'visible' : true
                            },
                            'filter': {
                                'type': 'date',
                            }
                        },
                        {
                            'id': 'sati',
                            'title': 'Sati',
                            'type' : 'text',
                            'column_visibility_group': {
                                'id': 'umanjeni_sat',
                                'visible' : true
                            },
                        },
                        {
                            'id': 'sati_regulativa',
                            'title': 'Sati regulativa',
                            'type' : 'text',
                            'column_visibility_group': {
                                'id': 'umanjeni_sat',
                                'visible' : true
                            },
                        }


                    ],
                    column_visibility_groups:{
                        'umanjeni_sat' : 'Umanjeni sat'
                    },
                    order: 'desc',
                    order_by: 'id',
                },
                title: 'Umanjeni sat',
            }
            vm.show_datatable = true;
        },

        setBreadcrumbs(){
            this.breadcrumbs = [
                {
                    path: '/osobe/' + this.osoba_id + '/umanjeni-sati',
                    name: 'Umanjeni sati'
                }
            ]
        }
    },
    mounted() {
        this.setDatatable()
        this.setBreadcrumbs()
    }
}
</script>

<style scoped>

</style>
